var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPurchaseSuccessIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.189453 18.0946V41.9054C0.189484 42.9918 0.475482 44.0591 1.01871 44.9999C1.56194 45.9409 2.34328 46.7221 3.28417 47.2654L23.9042 59.1708C24.8451 59.7141 25.9125 60 26.9989 60C28.0855 60 29.1527 59.7141 30.0936 59.1708L50.7137 47.2654C51.6547 46.7221 52.4359 45.9409 52.9792 44.9999C53.5225 44.0591 53.8084 42.9918 53.8084 41.9054V18.0946C53.8084 17.0082 53.5225 15.9409 52.9792 15.0001C52.4359 14.0591 51.6547 13.2778 50.7137 12.7346L30.0936 0.829221C29.1527 0.28599 28.0855 0 26.9989 0C25.9125 0 24.8451 0.28599 23.9042 0.829221L3.28417 12.7346C2.34328 13.2778 1.56194 14.0591 1.01871 15.0001C0.475482 15.9409 0.189484 17.0082 0.189453 18.0946Z",
    fill: "#009E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.189453 18.0946V41.9054C0.189484 42.9918 0.475482 44.0591 1.01871 44.9999C1.56194 45.9409 2.34328 46.7221 3.28417 47.2654L23.9042 59.1708C24.8451 59.7141 25.9125 60 26.9989 60C28.0855 60 29.1527 59.7141 30.0936 59.1708L50.7137 47.2654C51.6547 46.7221 52.4359 45.9409 52.9792 44.9999C53.5225 44.0591 53.8084 42.9918 53.8084 41.9054V18.0946C53.8084 17.0082 53.5225 15.9409 52.9792 15.0001C52.4359 14.0591 51.6547 13.2778 50.7137 12.7346L30.0936 0.829221C29.1527 0.28599 28.0855 0 26.9989 0C25.9125 0 24.8451 0.28599 23.9042 0.829221L3.28417 12.7346C2.34328 13.2778 1.56194 14.0591 1.01871 15.0001C0.475482 15.9409 0.189484 17.0082 0.189453 18.0946Z",
    fill: "url(#paint0_radial_8340_517125)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8340_517125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 60
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18371 43.7498L3.1838 43.75C3.50755 44.3107 3.97324 44.7764 4.5342 45.1004C4.53422 45.1004 4.53424 45.1004 4.53427 45.1004L25.1542 57.0057C25.7151 57.3295 26.3513 57.5 26.9989 57.5C27.6466 57.5 28.2827 57.3296 28.8436 57.0057L49.4637 45.1004C50.0246 44.7765 50.4903 44.3108 50.8142 43.7499L50.8142 43.7497C51.1379 43.1892 51.3084 42.553 51.3084 41.9054V18.0946C51.3084 17.447 51.1379 16.8108 50.8142 16.2503L50.8142 16.2501C50.4903 15.6891 50.0246 15.2235 49.4638 14.8997L49.4637 14.8996L28.8437 2.99431C28.8436 2.9943 28.8436 2.99428 28.8436 2.99427C28.2827 2.67044 27.6466 2.5 26.9989 2.5C26.3514 2.5 25.7151 2.67046 25.1542 2.99427C25.1542 2.99428 25.1542 2.9943 25.1542 2.99431L4.5342 14.8996L4.53418 14.8996C3.97331 15.2235 3.50759 15.6892 3.1838 16.25L3.18371 16.2502C2.85998 16.8108 2.68948 17.447 2.68945 18.0946L3.18371 43.7498ZM3.18371 43.7498C2.85998 43.1892 2.68948 42.553 2.68945 41.9054C2.68945 41.9053 2.68945 41.9053 2.68945 41.9053M3.18371 43.7498L2.68945 41.9053M2.68945 41.9053V18.0947V41.9053Z",
    stroke: "#143478",
    strokeWidth: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8340_517125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.8568,
    cy: 29.181,
    r: 33.3333,
    fill: "url(#paint1_linear_8340_517125)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5288 32.126C14.1974 30.7514 15.9635 30.3438 17.1669 31.2863L21.7702 34.8917C22.2568 35.2728 22.9533 35.2219 23.3794 34.7742L37.8514 19.5668C38.6988 18.6764 40.0819 18.5701 41.0554 19.3206L41.6671 19.7923C42.8031 20.6681 42.9222 22.3383 41.922 23.3665L24.2502 41.5326C23.3463 42.4618 21.8679 42.5053 20.911 41.6309L13.9231 35.2457C13.1382 34.5285 12.9187 33.3803 13.3838 32.4242L13.5288 32.126Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8340_517125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9989 30) rotate(90) scale(30 26.8095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EB8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8340_517125",
    x1: 26.8568,
    y1: -4.15234,
    x2: 26.8568,
    y2: 62.5143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E48A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB64"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPurchaseSuccessIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/purchase-success-icon.283db467766287dca58f1f677f5eec8d.svg";